GatorSurvey.app.directive("gsGridQuestion", ['surveyResponseService', GsGridQuestion]);
function GsGridQuestion(surveyResponseService) {
    return {
        restrict: 'AE',
        scope: {
            gsModel: "=ngModel",
            mode: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/Questions/Templates/GridQuestionLive.html',
        controller: ['$scope', function ($scope) {

            $scope.liveResponseModel = {};

            $scope.GetRowStyle = function (index) {
                if ($scope.gsModel.style.table.hasRowColours && index % 2) {
                    return { "background-color": $scope.gsModel.style.table.alternateRowColour };
                }
            };

            $scope.checkDisabled = function (col, row) {

                if (!$scope.gsModel.limitChecks)
                    return false;

                var list = Object.keys($scope.liveResponseModel);
                var finalList = {};
                for (var l = 0; l < list.length; l++) {
                    if (list[l].indexOf(row) > -1) {
                        finalList[list[l]] = $scope.liveResponseModel[list[l]];
                    }
                }
                list = Object.keys(finalList);

                if (finalList[col+"_"+row])
                    return false;
                var countCheck = 0;

                for (var i = 0; i < list.length; i++) {
                    var check = list[i];
                    if (finalList[check]) {
                        countCheck++;
                    }
                }
                return countCheck++ >= $scope.gsModel.unit;
            };

            $scope.addRemoveSelect = function (col, row) {
                var colId = $scope.getColId(col);
                var rowId = $scope.getRowId(row);
                surveyResponseService.updateResponseQuestion($scope.gsModel, $scope.liveResponseModel[colId + "_" + rowId], [rowId,colId]);
            };

            $scope.changeSelect = function (col, row) {
                var colId = $scope.getColId(col);
                var rowId = $scope.getRowId(row);
                surveyResponseService.updateResponseQuestion($scope.gsModel, colId, [rowId]);
            };

            $scope.getRowId = function(row) {
                return getUrlParameter("t") !== "1" ? row.id : row.tempId;
            };

            $scope.getColId = function (col) {
                return getUrlParameter("t") !== "1" ? col.id : col.tempId;
            };

            surveyResponseService.AddNewQuestion($scope.gsModel,
                    function(response) {
                        if (!$scope.gsModel.gridCheckbox) {
                            for (var gi = 0; gi < $scope.gsModel.grid.rows.length; gi++) {
                                for (var ga = 0; ga < response.gridAnswers.length; ga++) {
                                    if (response.gridAnswers[ga].id  === $scope.gsModel.grid.rows[gi].id) {
                                        $scope.gsModel.grid.rows[gi].input = response.gridAnswers[ga].selected;
                                    }
                                }
                            }
                        } else {
                            for (var lr = 0; lr < $scope.gsModel.grid.rows.length; lr++) {
                                var rowId = $scope.gsModel.grid.rows[lr].id;
                                for (var lc = 0; lc < $scope.gsModel.grid.cols.length; lc++) {
                                    var colId =  $scope.gsModel.grid.cols[lc].id;
                                    $scope.liveResponseModel[colId + "_" + rowId] = false;
                                }
                            }
                            for (var rsa = 0; rsa < response.gridCheckAnswers.length; rsa++) {
                                var row = response.gridCheckAnswers[rsa];
                                for (var cRsa = 0; cRsa < row.checkBoxes.length; cRsa++) {
                                    var col = row.checkBoxes[cRsa];
                                    $scope.liveResponseModel[col.col + "_" + row.id] = col.value;
                                }
                            }
                        }
                    });
            


        }]
    };
}